module.exports = __webpack_public_path__ + "cf3645f97222161e5c5eeff21a9fa288.png";